import * as ServiceReport from "../services/reports";
import Vue from "vue";
import store from "../store";
import i18n from "../translations";

export default {
  namespaced: true,
  state: {
    customer: {},
    cardCode: "",
    reports: [],
    reportsDetail: [],
    reportLoading: false,
    reportsTotal: 0,
    characteristics: "00",
    materialGroup: "00",
    dateFromAccounting: "",
    dateToAccounting: "",
    currentPageReports: 1,
    pageSize: 12,
  },
  actions: {
    async getReports(context, type, itemCode) {
      let cardCode = context.rootState.reports.customer.cardCode;
      let dateFromAccounting = context.rootState.reports.dateFromAccounting;
      let dateToAccounting = context.rootState.reports.dateToAccounting;
      // context.commit("reportLoading", true);
      let response = await ServiceReport.getSpecificSalesDataReport(
        type,
        cardCode,
        dateFromAccounting,
        dateToAccounting,
        {
          characteristics: context.rootState.reports.characteristics,
          materialGroup: context.rootState.reports.materialGroup,
          itemCode: itemCode ? itemCode : null,
        }
      )
        .then((response) => {
          debugger;
          context.commit("setReports", []);
          context.commit(
            "setReports",
            response.data.reportFormSubmit.allReports
          );
          context.commit(
            "setReportsTotal",
            response.data.reportFormSubmit.allReports.length
          );
        })
        .catch((response) => {
          console.log(response);
        });
      // context.commit("reportLoading", false);
    },
    async getReportsDetails(context, data) {
      debugger;
      let cardCode = context.rootState.reports.customer.cardCode;
      let dateFromAccounting = context.rootState.reports.dateFromAccounting;
      let dateToAccounting = context.rootState.reports.dateToAccounting;
      // context.commit("reportLoading", true);
      let response = await ServiceReport.getSpecificSalesDataReport(
        data.type,
        cardCode,
        dateFromAccounting,
        dateToAccounting,
        {
          characteristics: context.rootState.reports.characteristics,
          materialGroup: context.rootState.reports.materialGroup,
          itemCode: data.itemCode ? data.itemCode : null,
        }
      )
        .then((response) => {
          context.commit("setReportsDetails", []);
          context.commit(
            "setReportsDetails",
            response.data.reportFormSubmit.allReports
          );
        })
        .catch((response) => {
          console.log(response);
        });
      // context.commit("reportLoading", false);
    },
    async getCustomer(context) {
      let cardCode = context.rootState.cart.order.customer.cardCode;
      let response = await ServiceCustomer.getCustomers(cardCode);
      if (response.data) {
        context.commit(
          "setCustomer",
          response.data.customerByCardCode.allCustomerData[0]
        );
      } else {
        console.log(response);
      }
    },
    async getCurrentCustomer(context) {
      let cardCode = context.rootState.cart.order.customer.cardCode;
      let userId = context.rootState.auth.user.ownerCode;
      let response = await ServiceCustomer.getCustomers(cardCode, userId);
      if (response.data) {
        context.commit(
          "setCustomer",
          response.data.customerByCardCode.allCustomerData[0]
        );
        store.commit(
          "cart/setCustomerData",
          response.data.customerByCardCode.allCustomerData[0]
        );
        store.commit(
          "auth/setPaymentCustomer",
          response.data.customerByCardCode.allCustomerData[0].defaultPayment
        );
        store.commit(
          "currency/setCurrency",
          response.data.customerByCardCode.allCustomerData[0].defaultCurrency
        );
      } else {
        console.log(response);
      }
      return [];
    },
    async addCustomerShipping(context, data) {
      let cardCode = context.rootState.cart.order.customer.cardCode;
      let customerId = context.rootState.cart.order.customer.customerId;
      let response = await ServiceCustomer.setAddressForm(
        data,
        cardCode,
        customerId
      );
      if (response.data) {
        if (
          response.data.addressFormSubmit.shipping[0].response !== "success"
        ) {
          Vue.notify({
            group: "error",
            title: `${i18n.t("customer.addressNotAdded")}`,
            text: response.data.addressFormSubmit.shipping[0].response,
          });
          // throw new Error();
        } else {
          Vue.notify({
            group: "success",
            title: `${i18n.t("customer.addressAdded")}`,
            text: "",
          });
          context.commit(
            "addCustomerShipping",
            response.data.addressFormSubmit.shipping[0]
          );
        }
      } else {
        console.log(response);
      }
    },
    async updateCustomerShipping(context, data) {
      let cardCode = context.rootState.cart.order.customer.cardCode;
      let customerId = context.rootState.cart.order.customer.customerId;
      let response = await ServiceCustomer.setAddressForm(
        data,
        cardCode,
        customerId
      );
      if (response.data) {
        if (
          response.data.addressFormSubmit.shipping[0].response !== "success"
        ) {
          Vue.notify({
            group: "error",
            title: `${i18n.t("customer.addressNotUpdated")}`,
            text: response.data.addressFormSubmit.shipping[0].response,
          });
        } else {
          Vue.notify({
            group: "success",
            title: `${i18n.t("customer.addressUpdated")}`,
            text: "",
          });
          context.commit("updateCustomerShipping", data);
        }
      } else {
        console.log(response);
      }
    },
  },
  getters: {
    reportLoading: (state) => {
      return state.reportLoading;
    },
    reports: (state) => {
      return state.reports;
    },
    reportsDetail: (state) => {
      return state.reportsDetail;
    },
    customer: (state) => {
      return state.customer;
    },
    companyName: (state) => {
      return state.customer ? state.customer.company : "";
    },
    cardCode: (state) => {
      return state.cardCode;
    },
    shippingPageCount: (state, getters) => {
      return getters.customers.length > 0 ? getters.customers.length : 0;
    },
    materialGroup: (state) => {
      return state.materialGroup;
    },
    characteristics: (state) => {
      return state.characteristics;
    },
    processedReports: (state, getters) => {
      // return state.reports;
      let index = (state.currentPageReports - 1) * state.pageSize;
      return getters.reportsFilteredBy.slice(index, index + state.pageSize);
    },
    reportsFilteredBy: (state, getters) => {
      let reports = [];
      reports = getters.reports;
      return reports;
    },
    processedReportsTotal: (state, getters) => {
      return getters.reportsFilteredBy.length;
    },
    reportsPageCount: (state, getters) => {
      return Math.ceil(getters.processedReportsTotal / state.pageSize);
    },
    dateFromAccounting: (state, getters) => {
      return state.dateFromAccounting;
    },
    dateToAccounting: (state, getters) => {
      return state.dateToAccounting;
    },
  },
  mutations: {
    setReports(state, reports) {
      state.reports = reports;
    },
    setReportsDetails(state, reportsDetail) {
      state.reportsDetail = reportsDetail;
    },
    setReportsTotal(state, value) {
      state.reportsTotal = parseInt(value);
    },
    setDateFromAccounting(state, date) {
      state.dateFromAccounting = date;
    },
    setDateToAccounting(state, date) {
      state.dateToAccounting = date;
    },
    setReportLoading(state, newLoading) {
      state.reportLoading = newLoading;
    },
    setCustomer(state, customer) {
      state.customer = customer;
    },
    setCustomers(state, customer) {
      state.customers = customer;
      state.cardCode = customer.cardCode;
    },
    setCurrentPageReports(state, page) {
      state.currentPageReports = page;
      // return Math.ceil(getters.processedReportsTotal / state.pageSize)
      // this.dispatch("reports/getReports");
    },
    setPageSizeReports(state, size) {
      state.pageSize = size;
      state.currentPageReports = 1;
      // this.dispatch("reports/getReports");
    },
    setReportFilter(state, term) {
      state.currentPageReports = 1;
      // this.dispatch("reports/getReports");
    },
    setSearchCharacteristics(state, characteristics) {
      state.characteristics = characteristics;
      // this.dispatch('customers/getCustomers');
    },
    setSearchMaterialGroup(state, materialGroup) {
      state.materialGroup = materialGroup;
      // this.dispatch('customers/getCustomers');
    },
  },
};
